var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.title
    ? _c("div", { staticClass: "page-head" }, [
        _vm.title
          ? _c("h1", { domProps: { textContent: _vm._s(_vm.title) } })
          : _vm._e(),
        _vm.info
          ? _c("span", { domProps: { textContent: _vm._s(_vm.info) } })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }